import { FC, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { ReduxState } from 'reducers/rootReducer';
import { AddChartModal } from './AddChartModal';
import { AlertModal } from 'components/ds';
import { EditChartInfoModal } from './EditChartInfoModal';
import { EditChartPermissionsModal } from './EditChartPermissionsModal';

import { setEditableSectionModal } from 'reducers/dashboardEditConfigReducer';
import { deleteEditableSectionChartThunk } from 'reducers/thunks/editableSectionThunks';

export const EditableSectionModals: FC = () => {
  const dispatch = useDispatch();
  const { modal, charts } = useSelector(
    (state: ReduxState) => ({
      modal: state.dashboardEditConfig.editableSectionModal,
      charts: state.dashboardEditConfig.config?.editable_section?.charts,
    }),
    shallowEqual,
  );

  useEffect(() => {
    return () => {
      dispatch(setEditableSectionModal(null));
    };
  }, [dispatch]);

  switch (modal?.type) {
    case 'AddChart':
      return <AddChartModal />;
    case 'EditChartInfo': {
      const chart = charts?.[modal.chartId];
      if (!chart) return null;
      return <EditChartInfoModal chart={chart} />;
    }
    case 'EditChartPermissions': {
      const chart = charts?.[modal.chartId];
      if (!chart) return null;
      return <EditChartPermissionsModal chart={chart} />;
    }
    case 'DeleteChart': {
      const chart = charts?.[modal.chartId];
      if (!chart) return null;
      return (
        <AlertModal
          isOpen
          actionButtonProps={{
            onClick: () => dispatch(deleteEditableSectionChartThunk(modal.chartId)),
          }}
          onClose={() => dispatch(setEditableSectionModal(null))}
          title={`Are you sure you want to delete ${chart.name}`}
        />
      );
    }
    default:
      return null;
  }
};
